import { render, staticRenderFns } from "./AirportList.vue?vue&type=template&id=0642fa86&scoped=true"
import script from "./AirportList.vue?vue&type=script&lang=js"
export * from "./AirportList.vue?vue&type=script&lang=js"
import style0 from "./AirportList.vue?vue&type=style&index=0&id=0642fa86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0642fa86",
  null
  
)

export default component.exports